import {Component, OnInit, OnDestroy} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FaqService} from '../../../services/faq.service';
import {TagService} from '../../../services/tag.service';
import {Subject} from 'rxjs/Subject';
import {debounceTime} from 'rxjs/operators';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-faq-view',
  templateUrl: './faq-view.component.html',
  styleUrls: ['./faq-view.component.scss']
})
export class FaqViewComponent implements OnInit, OnDestroy {
  modelChanged: Subject<string> = new Subject<string>();
  faq = {id: '', 'tags': []};
  allTags: any[] = [];
  filteredTags: any[] = [];
  searchQuery: string = '';
  showDropdown: boolean = false;
  private routeSubscription: any;

  constructor(private graphqlService: FaqService,
              private utilsService: UtilsService,
              private tagService: TagService,
              private router: Router,
              private route: ActivatedRoute) {
    
    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateFaq());
  }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {
      if (params['id']) {
        const id = params['id'];
        this.loadFaq(id);
        this.loadTags();
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  loadFaq(id: string) {
    this.graphqlService.read(id).subscribe(result => {
      if (result && result.data) {
        this.faq = JSON.parse(JSON.stringify(result.data['faq']));
        this.utilsService.openSnackBar('Data Loaded !!', '');
      }
    });
  }

  loadTags() {
    this.tagService.listFaqForAutocomplete().subscribe(result => {
      if (result && result.data && result.data['tags'] && result.data['tags']['edges']) {
        this.allTags = result.data['tags']['edges'].map(edge => edge['node']);
        this.filteredTags = [...this.allTags];
      }
    });
  }

  // Custom tag input methods
  onTagInputFocus() {
    this.showDropdown = true;
    this.filterTags();
  }

  onTagInputBlur() {
    // Delay hiding dropdown to allow for clicks
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  onTagSearch(event: any) {
    this.searchQuery = event.target.value;
    this.filterTags();
  }

  filterTags() {
    if (!this.searchQuery) {
      this.filteredTags = this.allTags.filter(tag => 
        !this.faq.tags.some(selectedTag => selectedTag.id === tag.id)
      );
    } else {
      this.filteredTags = this.allTags.filter(tag => 
        tag.name.toLowerCase().includes(this.searchQuery.toLowerCase()) &&
        !this.faq.tags.some(selectedTag => selectedTag.id === tag.id)
      );
    }
  }

  addTag(tag: any) {
    if (this.faq.tags.length < 12 && !this.faq.tags.some(t => t.id === tag.id)) {
      this.faq.tags.push(tag);
      this.searchQuery = '';
      this.filterTags();
      this.dataChanged(null);
    }
  }

  removeTag(tagToRemove: any) {
    this.faq.tags = this.faq.tags.filter(tag => tag.id !== tagToRemove.id);
    this.filterTags();
    this.dataChanged(null);
  }

  dataChanged(event) {
    this.modelChanged.next();
  }

  updateFaq() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.faq['title']);
    if (requiredSuccess) {
      this.graphqlService.update(this.faq).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('FAQ Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update FAQ.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

  deleteFaq() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.graphqlService.delete(this.faq).subscribe(({data}) => {
      this.utilsService.openSnackBar('FAQ Deleted !!', '');
      this.router.navigate(['/faqs']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete faq.', '');
      console.log('there was an error sending the query', error);
    });
  }
}


// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/faqs/faq-view/faq-view.component.ts